//region block: pre-declaration
//endregion
function instanceOf(_this__u8e3s4, type) {
  return type.isInstance_6tn68w_k$(_this__u8e3s4);
}
//region block: exports
export {
  instanceOf as instanceOf2cx3k00nj6a0p,
};
//endregion

//# sourceMappingURL=TypeInfo.web.mjs.map
